export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.957 18.584a1.393 1.393 0 01-1.159 2.166H5.202a1.393 1.393 0 01-1.16-2.166l5.208-7.811V4.75H9a.75.75 0 110-1.5h6a.75.75 0 110 1.5h-.25v6.023l5.207 7.811zm-2.692-1.334l-3.889-5.834A.75.75 0 0113.25 11V4.75h-2.5V11a.75.75 0 01-.126.416l-3.89 5.834h10.531z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};